<template>
    <div class="myform">
        <form @submit="onSubmit" class="add-form">
            <div class="form-control">
                <b><label>Total Energy (kWh)</label></b>
                <input
                    type="number"
                    step="1.00"
                    v-model="electricity"
                    name="electricity"
                    placeholder="0.00"
                />
            </div>
            <div class="form-control">
                <b><label>Rate per kWh (MYR)</label></b>
                <input
                    type="number"
                    step="0.01"
                    v-model="rate"
                    name="rate"
                    placeholder="0.00"
                />
            </div>
            <p class="text-sm total-line">
                {{
                    rate > 0 && electricity > 0
                        ? `You earn: RM ${(rate * electricity).toFixed(2)}`
                        : None
                }}
            </p>
            <div class="form-control">
                <div class="donation">
                    <v-checkbox
                        v-model="isDonate"
                        :label="'I want to donate'"
                        class="align-center justify-center"
                    >
                    </v-checkbox>
                    <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                            <v-icon color="#989898" v-bind="props">
                                mdi-help-circle-outline
                            </v-icon>
                        </template>
                        <span>Seller's donation will be pooled and redistributed back to users as discounts! </span>
                    </v-tooltip>
                </div>
                <div class="donation-amount" v-show="isDonate">
                    <b><label>Total Donation (MYR)</label></b>
                    <input
                        type="number"
                        step="0.01"
                        v-model="donation"
                        name="donation"
                        placeholder="0.00"
                    />
                </div>
            </div>
            <div class="btn-block">
                <v-btn type="submit" class="ma-2" color="#ffd876"
                    >Create Listing</v-btn
                >
            </div>
        </form>
    </div>
</template>

<script>
import store from "@/store";
import { computed } from "vue";
import {
    getFirestore,
    collection,
    doc,
    setDoc,
    Timestamp,
} from "firebase/firestore";
export default {
    name: "AddListing",
    setup() {
        const user_name = computed(() => store.state.user?.name);
        const user_area = computed(() => store.state.user?.area);
        const user_city = computed(() => store.state.user?.city);
        const user_id = computed(() => store.state.user?.user_id);
        return {
            user_name,
            user_id,
            user_area,
            user_city,
        };
    },
    data() {
        return {
            rate: null,
            donation: "",
            electricity: null,
            isDonate: false,
        };
    },
    methods: {
        onSubmit(e) {
            e.preventDefault();
            console.log(this.rate);
            console.log(this.rate == "");
            console.log(this.electricity);

            if (!(this.rate != null && this.electricity != null)) {
                alert(
                    "Please ensure all fields are filled with positive values!"
                );
            } else if (
                this.rate <= 0 ||
                this.electricity <= 0 ||
                (this.donation != "" && this.donation <= 0)
            ) {
                alert(
                    "Please ensure all fields are filled with positive values!"
                );
            } else if (
                this.donation >
                parseFloat(this.rate) * parseFloat(this.electricity)
            ) {
                alert("Please enter a valid donation amount!");
            } else {
                const newListing = {
                    name: this.user_name,
                    user_id: this.user_id,
                    total_energy: this.electricity,
                    rate_per_kwh: this.rate.toFixed(2),
                    total_price: (
                        parseFloat(this.rate) * parseFloat(this.electricity)
                    ).toFixed(2),
                    location: `${this.user_area}/${this.user_city}`,
                    donation: this.donation,
                    date: Timestamp.fromDate(new Date()),
                    status: "Active",
                };
                // console.log(newListing);
                const db = getFirestore();
                const newListingRef = doc(collection(db, "listings"));
                newListing.id = newListingRef.id;
                setDoc(newListingRef, newListing);
                this.rate = "";
                this.donation = "";
                this.isDonate = false;
                this.electricity = "";
                this.$emit("add-listing", newListing);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.myform {
    border: 3px solid grey;
    border-radius: 25px;
    padding: 20px;
    width: 40%;
    margin: auto;
    margin-bottom: 20px;
}
.add-form {
    margin-bottom: 40px;
}
.form-control {
    margin: 20px 0;
}
.form-control label {
    display: block;
}
.form-control input {
    width: 100%;
    margin: 5px;
    margin-left: 0;
    padding: 10px 10px;
    font-size: 17px;
    border: 2px solid grey;
    border-radius: 10px;
}

.btn {
    display: inline-block;
    background: $yellow;
    color: $black;
    border: none;
    padding: 10px 20px;
    margin: 5px;
    border-radius: 5px;
    cursor: pointer;
    text-decoration: none;
    font-size: 15px;
    font-family: inherit;
}
.btn-block {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: -35px;
    margin-top : 10px;
}
.donation {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    .v-input {
        display: flex;
        justify-content: flex-start !important;
    }
}
.total-line {
    margin-top: -20px;
    margin-left: 5px;
}
</style>
